import { LitElement, html, css } from '~/lib/bn-lit-element';

import { sharedStyles } from '../styles/shared-styles';

class BnRadioInput extends LitElement {
  static get properties() {
    return {
      checked: { type: Boolean },
      disabled: { type: Boolean },
      required: { type: Boolean },
      name: { type: String },
      title: { type: String },
      values: { type: Array },
      missing: { type: Boolean, reflect: true },
      highlightErrors: { type: Boolean, attribute: 'highlight-errors', reflect: true },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .form-field {
        display: var(--bn-radio-input-display, block);
      }
      label {
        display: block;
        padding: var(--bn-radio-input-padding, inherit);
      }
      :host([missing]) label.group-label {
        transition: color .2s;
      }
      :host([missing][highlight-errors]) label.group-label {
        color: var(--red-20);
      }
      .required-label {
        margin-left: 0.125em;
      }
      .values {
        margin-top: .5rem;
      }
    `];
  }

  render() {
    const label = this.title || this.name;

    return html`
      <div class="form-field" title="${label} ${this.required ? '(required)' : ''}">
        <label class="group-label">${label}${this.required ? html`<span class="required-label">*</span>` : html``}</label>
        ${this._renderValues()}
      </div>
    `;
  }

  firstUpdated() {
    this.missing = this._isMissing();
  }

  _renderValues() {
    if (!this.values || !this.values.map) {
      return html``;
    }

    return html`
      <div class="values">
        ${this.values.map((item) => html`
          <label>
            <input
              type="radio"
              .value="${item.value}"
              .name="${this.name}"
              ?disabled="${this.disabled}"
              ?checked="${item.checked}"
              ?required="${this.required}"
              @input="${() => this._onInput(item)}"
            />
            ${item.title}
          </label>
        `)}
      </div>
    `;
  }

  get value() {
    const checkedInput = this.shadowRoot.querySelector('input[checked]');
    return checkedInput ? checkedInput.value : undefined;
  }

  _onInput(input) {
    this.values.forEach((val) => {
      val.checked = input.value === val.value;
    });

    this.missing = this._isMissing();
    this.requestUpdate();
  }

  _isMissing() {
    return !this.values.find((item) => item.checked);
  }
}

window.customElements.define('bn-radio-input', BnRadioInput);
